import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { apiDashboard } from 'Services/AuthService'
import { getFinancialYearDates } from 'Utils/helper'

export const getDashboard = createAsyncThunk('admin/dashboard/getDashboard', async datas => {
    const { data } = await apiDashboard(datas.guard, datas)
    return data
})

export const dashboardSlice = createSlice({
    name: 'admin/dashboard',
    initialState: {
        loading: true,
        ...getFinancialYearDates(),
        view: null,
    },
    reducers: {
        setDate: (state, { payload: { start, end } }) => {
            state.start = start
            state.end = end
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getDashboard.pending, state => {
                state.loading = true
                state.view = null
            })
            .addCase(getDashboard.fulfilled, (state, { payload }) => {
                state.loading = false
                state.view = payload
            })
    },
})

export const { setDate } = dashboardSlice.actions

export default dashboardSlice.reducer
